<template>
  <div class="tab-body">
    <div class="header-body">
      <el-row>
        <el-col :span="24">
          <el-row :span="24" :gutter="10">
            <el-col :span="16">
              <el-card class="box-card">

                <el-row :span="24" :gutter="20">
                  <span style="font-size: 16px; font-weight: 600;">&nbsp; &nbsp; 产品看板 &nbsp; &nbsp; &nbsp;</span>
                  <el-select v-model="value" placeholder="请选择" @change="listdata($event)">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-row>

                <hr style="margin-top: 10px;" />
                <el-row :span="24">
                  <el-col :span="20">
                    <!--  根看板内容地下的菜单 -->
                    <el-row :span="22">
                      <el-col :span="24" style="display: flex;font-size: 14px;">

                        <el-card :span="2" class="vertical-text">
                          进行中
                        </el-card>
                        <el-col :span="22"
                          style="display: flex;flex-direction:column;justify-content: space-between;margin-left: 10px;">
                          <el-row :span="24">
                            <el-card class="el-row-card">
                              <el-row>
                                <el-col :span="3">
                                  <div style="color: yellow; ">SPRINT</div>
                                </el-col>
                                <el-col :span="7">
                                  <div>进行中 x {{ headerParams.curSprint }}</div>
                                </el-col>
                                <el-col :span="7">
                                  <div>已完成 x {{ headerParams.finishStart }}</div>
                                </el-col>
                                <el-col :span="7">
                                  <div>未开始 x {{ headerParams.unStart }}</div>
                                </el-col>
                              </el-row>
                            </el-card>
                          </el-row>
                          <el-row :gutter="10">
                            <el-col :span="8">
                              <el-card class="el-row-card"><span class="el-icon-s-custom"> PO：{{ headerParams.pO
                              }}</span></el-card>
                            </el-col>
                            <el-col v-if="headerParams.allTeams != null" :span="8">
                              <el-card class="el-row-card"><span class="fa fa-group"> Team x {{ headerParams.allTeams
                              }}</span></el-card>
                            </el-col>
                            <el-col v-else :span="8">
                              <el-card class="el-row-card"><span class="el-icon-user-solid"> team x 0</span></el-card>
                            </el-col>
                            <el-col :span="8">
                              <el-card class="el-row-card"><span class="el-icon-user"> 人员 x {{ headerParams.userNum
                              }}人</span></el-card>
                            </el-col>
                          </el-row>
                        </el-col>

                      </el-col>
                    </el-row>
                    <!--  根看板内容地下的菜单  end -->
                    <el-row :span="24" :gutter="10" style="margin-left: -5px; margin-right: 5px;">
                      <el-col :span="8">
                        <el-card class="el-row-card" style="height: 68px;">
                          <div>产品周期：{{ product.allManDay }} 人/日</div>
                          <div style="font-size: 14;font-weight: 150;"> {{ headerParams.startTime }} 至 {{
                            headerParams.endTime }}</div>

                        </el-card>
                      </el-col>
                      <el-col :span="8">
                        <el-card class="el-row-card" style="height: 68px;">
                          待办完成：{{ headerParams.manDay }}/{{ product.allManDay }}
                          <el-progress :text-inside="true" :stroke-width="14" status="success"
                            :percentage="calculatePercentage(headerParams.manDay, product.allManDay)"></el-progress>
                        </el-card>
                      </el-col>
                      <el-col :span="8">
                        <el-card class="el-row-card" style="height: 68px;">SM.
                          <span v-for="sm in headerParams.sM"><el-tag size="mini" type="info">{{ sm }}</el-tag>
                            &nbsp;</span>

                        </el-card>
                      </el-col>
                    </el-row>

                  </el-col>

                  <el-col :span="4" style="margin-top: 7px;">
                    <!-- ---------------------- 用户故事 ---------------------------------- -->
                    <el-col :span="24" class="el-row-cent">
                      <el-col style="text-align: center ;">
                        <el-button type="text" @click="downloadStory">用户故事</el-button>
                      </el-col>

                      <hr style="margin-top:0px" />

                      <el-col style="text-align: center">
                        <el-button type="text" @click="downloadPGoal"><span>ProductGoal</span>
                        </el-button>
                      </el-col>

                      <hr style="margin-top: 0px" />

                      <el-col style="text-align: center">
                        <el-button type="text" @click="ToPBL"><span>PBL</span>
                        </el-button>
                      </el-col>

                      <hr style="margin-top: 0px" />

                      <el-col style="text-align: center">
                        <el-button type="text" @click="downloadDod"><span>DOD</span>
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>

            <!----------------------------------------------- 燃尽图 ---------------------------------------------->

            <!-- 燃尽图 -->
            <el-col :span="8">
              <el-card class="box-card">
                <el-row style="font-weight: bold">
                  <el-row>
                    <div id="myChart1" :style="{
                      width: '100%',
                      height: '251.5px',
                      backgroundColor: '#fff',
                    }" @dblclick="clickFullScreen"></div>

                  </el-row>
                </el-row>
              </el-card>
            </el-col>

          </el-row>
        </el-col>
      </el-row>

      <!------------------------------------------- Sprint列表 --------------------------------------------->
      <el-row :span="24" :gutter="10">
        <el-col :span="18">
          <el-card class="box-card" v-show="showInfo">

            <el-row :span="24" :gutter="10" style="margin-top: 5px; display: flex;flex-direction: row;flex-wrap: wrap;">
              <el-col :span="6" v-for="item in headerParams.sprintInfo">
                <!-- this -->
                <el-card shadow="never" :class="changecolor(item.state)">
                  <el-row style=" font-size: 15px; font-weight: bold">
                    {{ item.sprintName }}
                  </el-row>
                  <el-row style="margin-top: 5px">
                    项目总进度：{{ item.progress >= 0 ? item.progress : 0 }}%
                  </el-row>
                  <el-row style="font-size: 14px">
                    <el-col>
                      负责团队：<span style="color: #0d9276; font-size: 16px">
                        {{ item.teamName }}</span>
                    </el-col>
                    <el-col style="margin-top: 10px">
                      执行状态
                      <el-tag size="mini" type="info" v-if="item.state === '未开始'">未开始</el-tag>
                      <el-tag size="mini" v-else-if="item.state === '进行中'" type="danger">进行中</el-tag>
                      <el-tag size="mini" v-else-if="item.state === '已完成'" type="success">已完成</el-tag>
                      <el-tag size="mini" v-else-if="item.state === '已关闭'">已关闭</el-tag>
                      <el-tag size="mini" v-else-if="item.state === '已挂起'" type="warning">已挂起</el-tag>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <!---------------------------------------------动态 -------------------------------------------------->
          <el-card class="el-row-card" style="font-size: 16px;font-weight: bold;  text-align: center;"
            :body-style="{ padding: '10px' }">
            产 品 动 态
          </el-card>

          <div class="infinite-list-wrapper" v-infinite-scroll="loadTrendsPage" infinite-scroll-distance="20"
            style="height:480px;overflow:auto">
            <el-card class="box-card" v-for="item in trendsData" :body-style="{ padding: '10px' }">
              <el-row style="font-size: 14px; ">
                {{ item.crtm }}
                {{ item.dbColumn_crer }}
                {{ item.operate }}
                {{ item.problemSolving }}
              </el-row>
            </el-card>
          </div>

        </el-col>
      </el-row>
      <!---------------------------------------------------------- 抽屉 --------------------------------------------->
      <el-drawer :visible.sync="drawer" :with-header="false">
        <div class="tab-body">
          <el-row class="autoFlex">
            <el-col :span="24">
              <el-card class="leftCard">
                <div slot="header" class="clearfix">
                  <el-row type="flex" justify="center">
                    <span style="font-size: 24px">&nbsp;产品待办列表&nbsp;&nbsp;</span>
                  </el-row>
                </div>
                <div style="height: 572px">
                  <el-tree v-loading="treeLoading" ref="productTree" :data="productBacklogList"
                    :default-expand-all="treeExpand" @node-click="treeClick"></el-tree>
                </div>
                <el-button @click="closeDrawer()">返 回</el-button>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-drawer>

    </div>

    <!-- 展示文件 -->
    <show ref="show"></show>
    <!-- 检查pdf？ -->
    <showProductGoal ref="showProductGoal"></showProductGoal>
    <!-- pdf查看 -->
    <showDOD ref="showDOD"></showDOD>
  </div>
</template>

<script>
import api from "@/api/product/productBoard/productBoard.js";
import productBacklog from "@/api/product/productBacklog/productBacklog.js";
import productApi from "@/api/product/product/product.js";

import show from "./show.vue";
import showProductGoal from "./showProductGoal.vue";
import showDOD from "./showDOD.vue";

import PDF from "vue-pdf";
import QlhTable from "../../../components/qlhTable/qlhTable.vue";
import QlhTableColumn from "../../../components/qlhTable/qlhTableColumn.vue";
export default {
  components: {
    show,
    showProductGoal,
    PDF,
    showDOD,
    QlhTable,
    QlhTableColumn,
  },
  data() {
    return {

      chart: null,
      product: {}, // 当前产品
      chartData: {
        labels: ["Label1", "Label2", "Label3"], // 初始X轴数据
        datasets: [
          {
            label: "Data",
            data: [10, 20, 30], // 对应X轴的数据点
          },
        ],
      },


      headerParams: {
        pO: "",
        sM: "",
      },
      productArr: [], //产品id
      options: [], //产品名字
      value: "",
      productList: [],
      treeExpand: true,
      productBacklogList: [],
      drawer: false,
      treeLoading: false,
      showInfo: false,
      UserStorydrawer: false,
      echartsdata: {},
      chartsstyle: {
        width: "100%",
        height: "400px",
      },
      myChart1: {},
      productGoalData: {}, //产品目标数据

      trendsData: [], //动态表数据
      page: new this.$constant.pageObj(),
      loading: false,

      //x轴数据
      xData: [],

      // 燃尽图数据
      option: {
        title: {
          text: "工时燃烬图",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["计划消耗", "实际剩余"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true,
        },


        //全屏的逻辑,echarts自带的组件
        toolbox: {
          feature: {
            myFull: {
              show: true,
              title: "全屏",
              icon: "path://M796.1 262.5S874.4 447.8 650.6 659c0 0 117.4-21.8 168.3-155.6s-22.8-240.9-22.8-240.9zM803.2 822.8s-10.4 90.7-101.4 107.3c0 0 11.2 45.7 85.8-7.8s15.6-99.5 15.6-99.5zM841.5 879.7c-1.2-6.8-2.7-16-91.7-168.4-14.9-25.4-29.7-50.7-42.8-72.9-6.2 4.9-13.1 9.1-20.3 13 51.2 86.6 129 219.8 131.1 232.3 3.2 18.5-76 52.1-92.6 52.1h-0.6c-10.7-0.6-70.6-155.9-105.3-248.4-7.9 1.1-15.2 4.9-23.1 7 10.2 27.1 22.5 59.6 35.1 92 17.9 46 32.9 82.8 44.4 109.3 7.1 16.3 12.9 28.6 17.6 37.5 5.7 10.8 13.6 25.7 29.9 26.6 0.6 0 1.2 0.1 1.9 0.1 21.7 0 87.3-27.7 107.2-51.3 9.8-11.4 10.4-22 9.2-28.9zM496.4 88.1c52.9 0 106.5 12.9 154.8 40 98 55 176.8 158.1 175 274.2-0.2 10.4-1 20.7-2.4 31-21.7 154.3-178 264.1-330.5 264.1-32.2 0-64.2-4.9-94.8-15.3-140.3-47.8-220.7-218-196.3-359.4 12.9-74.4 52.3-133 105.5-173 53.3-40.1 120.4-61.6 188.7-61.6m0-24.1c-74.1 0-146.3 23.6-203.2 66.4-61.8 46.5-101.5 111.6-114.8 188.2-12.9 74.4 1.2 158.3 38.7 230.1 39.8 76.2 101.4 131.7 173.5 156.3 32.3 11 66.8 16.6 102.5 16.6 80 0 163.4-28.9 228.9-79.2 69.7-53.6 114.3-126.6 125.4-205.7 1.6-11.2 2.5-22.6 2.6-33.9 0.9-59.6-17.8-119.8-54.2-173.8-33.3-49.4-79.3-91.5-133.1-121.8C612.7 78.9 555.1 64 496.4 64zM760.9 593.4c-2.1 0-4.1-0.8-5.7-2.4l-14-14c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l14.1 14.1c3.1 3.1 3.1 8.2 0 11.4-1.6 1.5-3.7 2.3-5.8 2.3zM741.1 621.9c-2.1 0-4.1-0.8-5.7-2.4l-18.2-18.2c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l18.2 18.2c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM821.1 900.7c-2.1 0-4.1-0.8-5.7-2.4l-22.1-22.1c-3.1-3.1-3.1-8.2 0-11.4s8.2-3.1 11.4 0l22.1 22.1c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM803.2 924.9c-2.1 0-4.1-0.8-5.7-2.4l-20.8-20.8c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.8 20.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM777 938.6c-2.1 0-4.1-0.8-5.7-2.4L755.1 920c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l16.2 16.2c3.1 3.1 3.1 8.2 0 11.4-1.6 1.7-3.6 2.4-5.7 2.4zM750.1 952.8c-2.1 0-4.1-0.8-5.7-2.4L730 936c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l14.4 14.4c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM782.8 564.8c-2.1 0-4.1-0.8-5.7-2.4l-16.8-16.8c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l16.8 16.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM806.5 536.8c-2.1 0-4.1-0.8-5.7-2.4L780 513.6c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.8 20.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.6 2.4-5.7 2.4zM820.5 498.3c-2.1 0-4.1-0.8-5.7-2.4L797 478.1c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l17.8 17.8c3.1 3.1 3.1 8.2 0 11.4-1.6 1.7-3.6 2.4-5.7 2.4zM834.6 462.8c-2.1 0-4.1-0.8-5.7-2.4L808 439.5c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l20.9 20.9c3.1 3.1 3.1 8.2 0 11.4-1.6 1.6-3.7 2.4-5.7 2.4zM840.1 417.2c-2.1 0-4.1-0.8-5.7-2.4L812.5 393c-3.1-3.1-3.1-8.2 0-11.4 3.1-3.1 8.2-3.1 11.4 0l21.9 21.9c3.1 3.1 3.1 8.2 0 11.4-1.6 1.5-3.7 2.3-5.7 2.3zM500.2 163.6c39.8 0 80.1 9.7 116.5 30.1 73.7 41.4 133.1 119 131.7 206.4-0.1 7.8-0.7 15.6-1.8 23.3-16.3 116.2-134 198.8-248.7 198.8-24.2 0-48.3-3.7-71.3-11.5-105.6-36-166.1-164.1-147.7-270.5 9.7-56 39.4-100.1 79.4-130.2 40-30.3 90.5-46.4 141.9-46.4m0-24.1c-57.1 0-112.6 18.2-156.5 51.2-47.8 35.9-78.4 86.2-88.7 145.4-9.9 57.3 0.9 121.8 29.7 177 30.7 58.7 78.3 101.5 134 120.5 24.9 8.5 51.6 12.8 79.1 12.8 61.5 0 125.6-22.2 175.9-60.8 53.7-41.3 88.1-97.6 96.6-158.7 1.2-8.7 1.9-17.5 2-26.3 0.7-46.1-13.7-92.5-41.8-134.3-25.6-38-60.9-70.3-102.2-93.5-38.5-21.9-82.9-33.3-128.1-33.3zM409.1 235.8s-57.7 44.4-63.3 88.8M345.8 336.7c-0.5 0-1 0-1.5-0.1-6.6-0.8-11.3-6.9-10.4-13.5 6.1-48.8 65.3-94.9 67.9-96.8 5.3-4.1 12.8-3.1 16.9 2.2s3.1 12.8-2.2 16.9c-14.9 11.5-54.6 48.5-58.7 80.7-0.8 6.1-6 10.6-12 10.6zM333.4 412.1c-0.4 0-0.8 0-1.2-0.1-6.6-0.7-11.4-6.6-10.8-13.2l2.6-25.6c0.7-6.6 6.6-11.4 13.2-10.8 6.6 0.7 11.4 6.6 10.8 13.2l-2.6 25.6c-0.7 6.3-5.9 10.9-12 10.9z",
              onclick: (e) => {
                const element = document.getElementById("myChart1");


                //全屏适配的逻辑
                // 一些浏览器的兼容性
                if (element.requestFullScreen) {
                  // HTML W3C 提议
                  element.requestFullScreen();
                } else if (element.msRequestFullscreen) {
                  // IE11
                  element.msRequestFullScreen();
                } else if (element.webkitRequestFullScreen) {
                  // Webkit (works in Safari5.1 and Chrome 15)
                  element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                  // Firefox (works in nightly)
                  element.mozRequestFullScreen();
                }

                // 退出全屏
                if (element.requestFullScreen) {
                  document.exitFullscreen();
                } else if (element.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (element.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (element.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            formatter: function (value) {
              return value.substr(5);
            },
            rotate: -90, // 旋转标签，保持纵向显示
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "计划",
            type: "line",
          },
          {
            name: "实际剩余工时",
            type: "line",
          },
        ],
        color: ["#CC0000", "#336699"],
      },


    };
  }, computed: {
    noMore() {
      return this.page.current >= this.page.pages
    },
    disabled() {
      return this.loading || this.noMore
    }
  },

  methods: {
    calculatePercentage(manDay, allManDay) {
      if (!manDay || allManDay === 0) {
        return 0;
      }
      const percentage = (manDay / allManDay) * 100;
      if (percentage > 100) {
        return 100;
      }
      return parseFloat(percentage.toFixed(2));
    },

    loadTrendsPage() {

      if (this.page.current < this.page.pages) {
        this.page.current++;
        this.getTrendsList()
      }

    },

    changecolor(valu) {
      if (valu == "未开始") {
        return 'box-card-a1'
      } else if (valu == "进行中") {
        return 'box-card-a2'
      } else {
        return 'box-card-a3'
      }
    },

    //获取所有产品id和名字
    list(parameter) {
      this.myChart1 = this.$echarts.init(document.getElementById("myChart1"));
      this.treeLoading = true;

      //const productId = localStorage.getItem("pid");
      const productId = this.$caches.pid.get();
      console.log('productId ====frist====== ', productId);
      if (productId) {
        productBacklog.list({ productId: productId }, (response) => {
          this.productBacklogList = response.data;

          this.treeLoading = false;
        });
        //拿到所有的产品,并且赋予默认值
        productApi.list3({}, (response) => {
          this.productList = response.data.records;
          this.productList.forEach((item) => {
            if (item.id === productId) {
              //设置产品的默认值
              this.selectProd = item.id;
              return;
            }
          });
        });
      } else {
        //拿到所有的产品
        productApi.list3({}, (response) => {
          this.productList = response.data.records;
        });
        console.log('this.productList ====== ', this.productList)
        this.treeLoading = false;
      }

      //下拉框产品名字
      let params = this.productArr;
      api.productList(params, (response) => {
        params = response.data;
        this.productArr = response.data;
        for (let idx = 0; idx < params.length; idx++) {
          this.options.push({
            value: params[idx].id,
            label: params[idx].name,
          });
        }

        //尝试取得前端存储的pid
        let pid = this.$caches.pid.get();
        console.log('productId ====two====== ', pid);
        if (!pid) {
          //默认第一个
          if (this.options[0]) {
            pid = this.options[0].value;
          }
        }
        console.log('productId ====thrld====== ', pid);
        this.listdata(pid); //获取下拉框Id的产品信息
        this.getProductGoalData(); //获取该产品的产品目标
      });
    },
    //点击部门
    treeClick(data) {
      if (data) {
        this.currentNode = data;
        if (this.currentNode.children) {
          this.rightTitle =
            this.currentNode.level + 1 + "级待办 - " + this.currentNode.label;
        } else {
          this.rightTitle = this.currentNode.level + 1 + "级,最后一级";
        }
        this.productBacklogTable = data.children;
      } else {
        this.productBacklogTable = this.productBacklogList;
      }
    },

    listdata(id) {
      //前端存储
      this.$caches.pid.set(id);

      let params = { id: id };
      //回显select
      this.value = id;

      //取得当前产品
      productApi.toUpdate({ id: id }, (response) => {
        this.product = response.data;
        this.trendsData = [];
        this.page = new this.$constant.pageObj();
        this.getTrendsList();

      });

      let sms = "";
      this.showInfo = true;
      api.headerlist(params, (response) => {

        this.headerParams = response.data;

      });
      this.getProductGoalData(id);
      this.chartlist(id);

      //1. 先将id存储到本地存储中,从而下一次来的时候可以直接查询当前产品的产品待办列表
      localStorage.setItem("pid", id);
      //2. 发起查询,查询出对应产品的所有待办列表
      productBacklog.list({ productId: id }, (response) => {
        this.productBacklogList = response.data;
        this.treeLoading = false;
      });
    },
    //取得产品目标的数据
    getProductGoalData() {
      let pid = this.$caches.pid.get();
      let params = { id: pid };
      api.productGoalData(params, (response) => {
        this.productGoalData = response.data.goal;
      });
    },
    //x轴
    chartlist(id) {
      let params = { id: id };
      api.chartlist(params, (response) => {
        this.xData = response.data;
        //燃尽图
        this.option.xAxis.data = this.xData.xAxisData;
        this.option.series[0].data = this.xData.seriesData1;
        this.option.series[1].data = this.xData.seriesData2;

        //防止越界，重绘canvas，解决掉屏幕缩小，图表不会随之适应的缩小的方法
        window.onresize = this.myChart1.resize;
        //设置option
        this.myChart1.setOption(this.option);
      });
    },

    //下载用户故事
    downloadStory() {
      this.$refs.show.open(this.product.userStory, "查看用户故事");
    },
    //下载产品目标
    downloadPGoal() {
      this.$refs.showProductGoal.open(this.productGoalData, "查看产品目标");
    },
    //预览DOD产品定义
    downloadDod() {
      this.$refs.showProductGoal.open(this.product.boundary, "查看产品定义");
    },
    //跳转到PBL页面
    ToPBL() {
      this.drawer = true;
    },
    //关闭纪要弹窗
    closeDrawer() {
      this.drawer = false;
    },
    //获取动态信息

    getTrendsList() {
      this.loading = true
      console.log("product 2", this.product)

      let params = this.$utils.merger({ id: this.product.id }, this.page);

      api.trendslist(params, (response) => {
        this.page.current = response.data.current
        this.page.pages = response.data.pages
        console.log("this.page", this.page)
        this.trendsData = this.trendsData.concat(response.data.records);
        this.loading = false
        // console.log(response.data);
      });
    },

    //双击图表全屏
    clickFullScreen() {
      this.myChart1.setOption(this.option);

      const burnoutChart = document.getElementById("myChart1");

      //全屏适配的逻辑
      // 一些浏览器的兼容性
      if (burnoutChart.requestFullScreen) {
        // HTML W3C 提议
        burnoutChart.requestFullScreen();
      } else if (burnoutChart.msRequestFullscreen) {
        // IE11
        burnoutChart.msRequestFullScreen();
      } else if (burnoutChart.webkitRequestFullScreen) {
        // Webkit (works in Safari5.1 and Chrome 15)
        burnoutChart.webkitRequestFullScreen();
      } else if (burnoutChart.mozRequestFullScreen) {
        // Firefox (works in nightly)
        burnoutChart.mozRequestFullScreen();
      }

      // 退出全屏
      if (burnoutChart.requestFullScreen) {
        document.exitFullscreen();
      } else if (burnoutChart.msRequestFullScreen) {
        document.msExitFullscreen();
      } else if (burnoutChart.webkitRequestFullScreen) {
        document.webkitCancelFullScreen();
      } else if (burnoutChart.mozRequestFullScreen) {
        document.mozCancelFullScreen();
      }

      // console.log("1123123");


    },
  },
  mounted() {
    this.list();
    this.page.size = 10;
  },
};
</script>

<style>
.el-collapse-item__header {
  /* color: #409eff; */
  font-size: 14px;
  font-weight: 600;
}

.tab-body {
  .el-row {
    padding: 3px;
    /* background-color: aqua; */
  }
}

.Message-coloapse em {
  font-style: normal;
  padding: 0 10px;
  color: #303133;
}

.Message-coloapse span {
  font-weight: 700;
  /* color: #009688; */

}


/* 修改 */
.box-card-a1 {
  background-color: rgb(224, 174, 174);
  border-color: black;
  margin-bottom: 15px;
}

.box-card-a2 {
  background-color: rgb(235, 229, 144);
  border-color: black;
  margin-bottom: 10px;
}

.box-card-a3 {
  background-color: rgb(167, 223, 165);
  border-color: black;
  margin-bottom: 15px;
}

.el-col-btn {
  border-radius: 4px;
  background-color: rgb(234, 239, 239);
  font-weight: 600;
}

.vertical-text {
  writing-mode: vertical-lr;
  border-radius: 5px;
  font-weight: 600;
  font-size: 22px;
  height: 120px;
  color: hsl(0, 0%, 100%);
  background-color: rgb(18, 74, 158);
  display: flex;
  justify-content: center;
  align-items: center;
}



.el-row-card {
  font-size: 16px;
  font-weight: 600;
  background-color: #4b88bd;
  color: #fff;
}

.el-row-cent {
  background-color: rgb(208, 197, 158);
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 187.5px;
}



.el-card__body,
.el-main {
  padding: 15px;
}
</style>
